const loader = document.querySelector('[data-site-loader]');
const config = window.AbdelmegedTheme || {};
const reducedMotion = () => document.documentElement.dataset.reducedMotion === 'true';

if (loader) {
  const loaderLogo = loader.querySelector('[data-logo-loader]');
  const canWaitForLogo = Boolean(loaderLogo)
    && config.features?.logoAnimation === true
    && !reducedMotion();

  let pageReady = document.readyState !== 'loading';
  let minimumElapsed = false;
  let mediaFinished = !canWaitForLogo;
  let hidden = false;

  const hide = () => {
    if (hidden) {
      return;
    }

    hidden = true;
    loader.classList.add('is-hidden');
    loader.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('abdelmeged-loader-active');

    window.dispatchEvent(new CustomEvent('abdelmeged:loader-hidden'));

    window.setTimeout(() => {
      loader.remove();
    }, 420);
  };

  const maybeHide = () => {
    if (pageReady && minimumElapsed && mediaFinished) {
      hide();
    }
  };

  const finishMedia = () => {
    mediaFinished = true;
    maybeHide();
  };

  document.documentElement.classList.add('abdelmeged-loader-active');

  window.setTimeout(() => {
    minimumElapsed = true;
    maybeHide();
  }, canWaitForLogo ? 900 : 180);

  window.setTimeout(() => {
    finishMedia();
  }, canWaitForLogo ? 3800 : 500);

  document.addEventListener('DOMContentLoaded', () => {
    pageReady = true;
    maybeHide();
  }, { once: true });

  document.addEventListener('abdelmeged:logo-animation-complete', (event) => {
    if (loader.contains(event.target)) {
      finishMedia();
    }
  });

  document.addEventListener('abdelmeged:logo-animation-skipped', (event) => {
    if (loader.contains(event.target)) {
      finishMedia();
    }
  });
}
